/* eslint-disable no-console */
import { handleErrors } from './ErrorActions';
import smartSolveApi from '../api/instances/smartsolve';
import { downloadFile } from '../utils/domUtils';
import { getCompareFileName } from '../utils/formHistoryUtils';

export const SET_OPEN_FORM_HISTORY_MODAL = 'SET_FORM_HISTORY_MODAL';
export const CLEAR_FORM_HISTORY_MODAL = 'CLEAR_FORM_HISTORY_MODAL';
export const FETCH_FORM_HISTORY_SUCCESS = 'FETCH_FORM_HISTORY_SUCCESS';

export const setOpenFormHistoryModal = (isOpen) => ({
  type: SET_OPEN_FORM_HISTORY_MODAL,
  isOpen,
});

export const clearFormHistoryModal = () => ({
  type: CLEAR_FORM_HISTORY_MODAL,
});

const fetchFormHistorySuccess = ({ rows }) => ({
  type: FETCH_FORM_HISTORY_SUCCESS,
  rows,
});

export const fetchFormHistoryFromServer = (formKey) => async (dispatch) => {
  try {
    const response = await smartSolveApi.post('/forms/history', { formKey });
    const { data } = response;
    if (data.hasError) {
      dispatch(handleErrors(data.errors));
    } else {
      dispatch(fetchFormHistorySuccess({ rows: data.history ?? [] }));
    }
  } catch (error) {
    console.error(`Fetching Form History failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const exportForm = ({ formId, fileName = 'form_definition' }) => async () => {
  try {
    const response = await smartSolveApi.post('/forms/export', { formId });
    downloadFile(`${fileName}.xml`, response.data, 3);
  } catch (error) {
    throw new Error(`exportForm() failed: ${error}`);
  }
};

export const compareForms = ({ formKey, baselineVersion, compareToVersion }) => async () => {
  try {
    const fileName = getCompareFileName({ baselineVersion, compareToVersion });
    const response = await smartSolveApi.post('/forms/compare', {
      formKey,
      id1: baselineVersion.OPS_ID,
      id2: compareToVersion.OPS_ID,
    });
    downloadFile(`${fileName}.html`, response.data, 1);
  } catch (error) {
    throw new Error(`compareForms() failed: ${error}`);
  }
};
